import { Component } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'pioneer-generic-error',
  templateUrl: 'generic-error.component.html'
})
export class GenericErrorComponent {
  error = 'MESSAGES.ERROR.GENERIC_ERROR';

  constructor(private route: ActivatedRoute) {
    this.route.params.subscribe((params: Params) => {
      if (params[ 'error' ]) {
        this.error = params[ 'error' ];
      }
    });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/generic-error/generic-error.component.ts